import * as React from 'react';

import BaseSettingsLayout from './BaseSettingsLayout';
import UserProfile from '../containers/settings/UserProfile';

export default function () {
  return BaseSettingsLayout(
    <UserProfile />
  );
};
